import { QueryStatus } from '@reduxjs/toolkit/query';

export const UNLOADED_STATUS = new Set([QueryStatus.uninitialized, QueryStatus.pending]);
